export const insightCardTitleStyles = {
  minWidth: 0,
  color: "#091F3A",
  fontSize: 16,
  fontWeight: 800,
  lineHeight: 1.3
} satisfies SxProps<Theme>;

export const insightCardToggleStyles = {
  minWidth: 112,
  minHeight: 36,
  px: 1.5,
  borderRadius: "6px",
  whiteSpace: "nowrap",
  textTransform: "none",
  fontSize: 13,
  fontWeight: 700,
  flexShrink: 0,
  bgcolor: "#0F6CBD",
  color: "#FFFFFF",
  "&:hover": {
    bgcolor: "#0B579A"
  },
  "&.Mui-focusVisible": {
    outline: "3px solid #80BFFF",
    outlineOffset: 2
  }
} satisfies SxProps<Theme>;
import { SxProps, Theme } from "@mui/material/styles";
